import { createReducer, createRequestReducer } from '../../utils';
import { DATA_SET_LAYOUT, GET_PAGE_STATS, SWITCH_PANEL } from './constants';

function calcLayout() {
  if (typeof window === 'undefined') {
    return 'desktop';
  }

  return (window.innerWidth > 989)
    ? 'desktop'
    : (window.innerWidth > 767 ? 'tablet' : 'mobile');
}

const initialState = {
  layout: 'desktop',
  width: null,
  pageStats: {},
  panel: null
};

export default createReducer(initialState, {
  [DATA_SET_LAYOUT]: (state, action) => {
    return Object.assign(state, {
      layout: calcLayout(action.width),
      width: action.width
    });
  },

  [GET_PAGE_STATS]: (state, action) => createRequestReducer(state, action, {
    SUCCESS: (state, action) => ({
      ...state,
      pageStats: action.request.response
    })
  }),

  [SWITCH_PANEL]: (state, action) => {
    return Object.assign(state, {
      panel: action.panel
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/App/reducer.js